import React, { memo } from "react";
import { HStack, VStack } from "@UI/Components/Stack/Stack";

import { Text } from "@UI/Components/Text/Text";
import { Box } from "@UI/Components/Box/Box";
import { Image } from "@UI/Components/Image/Image";

import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

interface FrequentJobBannerProps {
  spName: string;
}

export const FrequentJobBanner = memo(({ spName }: FrequentJobBannerProps) => {
  return (
    <Box
      w={{ base: "full", lg: "320px", xl: "360px" }}
      background="white"
      borderRadius="10px"
      p="16px"
    >
        <HStack spacing="12px" alignItems="center">
          <Image
            src={require("assets/images/recurrency/main-icon.svg")}
            w="32px"
            h="32px"
            alt="recurrent"
            flexShrink={0}
          />
          <VStack spacing="4px" alignItems="start">
            <Text m="0" fontSize="sm">
              <FormattedMessage
                {...messages["serviceRequest.frequentJob.title"]}
              />
            </Text>
            <Text m="0" fontSize="sm" color="gray.700">
              <FormattedMessage
                {...messages["serviceRequest.frequentJob.body"]}
                values={{ spName }}
              />
            </Text>
            <Text m="0" fontSize="xs" color="gray.500">
              <FormattedMessage
                {...messages["serviceRequest.frequentJob.addressNote"]}
              />
            </Text>
          </VStack>
        </HStack>
    </Box>
  );
});

FrequentJobBanner.displayName = "FrequentJobBanner";
